// widgets/index.js
import CurrentIdentity from "./Identity/CurrentIdentity";
import FutureIdentity from "./Identity/FutureIdentity";
import UnmetNeeds from "./Module2/UnmetNeeds";
import ValuesMapping from "./Module2/ValuesMapping";
import FutureValuesMapping from "./Module2/FutureValuesMapping";
import StakeholdersList from "./Stakeholders/StakeholderListContainer";
import StakeholderValuesContainer from "./Stakeholders/StakeholderValuesContainer";
// import StakeholderValuesAndInterests from "./Stakeholders/StakeholderValuesAndInterests";
import StakeholdersMap from "./Stakeholders/StakeholderMapContainer";
import BeliefScreenContainer from "./Module4/BeliefContainer";
import UnderlyingRootcauseContainer from "./Module4/RootcauseContainer";

import BuildingNarrativeContainer from "./Module6/BuildingNarrativeContainer";
// import RefinePitchContainer from "./Module5/RefinePitchContainer";
// import RefineBrandContainer from "./Module5/RefineBrandContainer";
import EnergyExpenditureAudit from "./Module5/EnergyExpenditureAudit";
import VisualizeFuture from "./Module7/VisualizeFuture";
import EbookScreen from "../EbookScreen";

// Registry of all widgets

export const widgetRegistry = {
  current_identity: CurrentIdentity,
  future_identity: FutureIdentity,
  politics_ebook: EbookScreen,

  unmet_needs: UnmetNeeds, 

  values_mapping: ValuesMapping, 
  future_values_mapping: FutureValuesMapping,

  stakeholder_list: StakeholdersList, 
  stakeholder_values: StakeholderValuesContainer,
  stakeholder_map: StakeholdersMap,

  my_beliefs: BeliefScreenContainer, 
  underlying_root_cause: UnderlyingRootcauseContainer, 

  building_narrative: BuildingNarrativeContainer,

  energy_expenditure_audit: EnergyExpenditureAudit,
  
  visualize_future: VisualizeFuture,
};
